module.exports = __webpack_public_path__ + "static/favicon-776d15b35be9ef0bd2ed2db2c011594b.ico";